import React from 'react'
import { ReactComponent } from './Close.svg'
import { MergeReactElementProps } from '../types'

interface CloseProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', CloseProps>

export const Close = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
